<template>
  <span :style="cssProps">
    <v-progress-linear indeterminate v-if="currentLoading"></v-progress-linear>
    <v-row align="center" class="res-action-group-header">
      <v-col cols="11" class="left-top-bordered">
        <v-checkbox hide-details color="var(--v-resBlue-darken1)" dense v-model="params.data.isSelected" @change="onRowSelectedChanged" class="mx-2 ma-0 pb-2 res-checkbox">
          <template v-slot:label>
            <span class="pl-1 group-label">
              {{params.data.label}}
              <template v-for="quickAction in params.data.leftActions">

                <v-tooltip top max-width="600" :key="quickAction.name">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dense v-bind="attrs" v-on="on" :class="'quick-icon ' + getParameterizedResult(quickAction.class, params)" class="ml-3 quick-icon" @click.stop="performAction(quickAction, params)">{{getParameterizedResult(quickAction.icon, params)}}</v-icon>
                  </template>
                  <span>{{getParameterizedResult(quickAction.label, params)}}</span>
                  <div v-if="getParameterizedResult(quickAction.label2, params)"><br/>{{getParameterizedResult(quickAction.label2, params)}}</div>
                </v-tooltip>

              </template>
            </span>
          </template>
        </v-checkbox>
        
      </v-col>
      <v-col cols="1" class="right-top-bordered pl-0">
        <div class="action-controls">
          <template v-for="quickAction in params.data.rightActions">

            <v-tooltip bottom :key="quickAction.name">
              <template v-slot:activator="{ on, attrs }">
                <v-icon dense v-bind="attrs" v-on="on" :class="'quick-icon ' + getParameterizedResult(quickAction.class, params)" class="mr-3 quick-icon" @click.stop="performAction(quickAction, params)">{{getParameterizedResult(quickAction.icon, params)}}</v-icon>
              </template>
              <span>{{getParameterizedResult(quickAction.label, params)}}</span>
            </v-tooltip>

          </template>
          <v-menu v-if="params.data.actions.length > 0" left offset-y close-on-click @input="updateMenuState">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon :color="menuColor" class="ellipses-control">
                <v-icon dense>{{menuIcon}}</v-icon>
              </v-btn>
            </template>
            <v-list class="ellipses-control-option-list">
              <template v-for="(action, index) in params.data.actions">
                <v-list-item v-if="action" :key="action.name" @click.stop="performAction(action, params)">
                  <v-list-item-title class="ellipses-control-option">{{getParameterizedResult(action.label, params)}}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!action" :key="index" class="py-0 my-0">---------------------------------------</v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </span>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'ResActionGroupHeader',
    props: {
      actions: {
        type: Array,
        default: function () { return [] }
      },
      label: {
        type: String,
        default: 'Group'
      },
      minWidth: {
        type: Number,
        default: 0
      }
    },
    data: () => {
      return {
        menuOpen: false
      };
    },
    computed: {
      ...mapGetters(['currentLoading']),
      cssProps() {
        return {
          '--min-width-stretch': this.minWidth + 'px;' + (this.currentLoading ? 'opacity: 0.75 !important;' : '')
        }
      },
      menuIcon() {
        return this.menuOpen ? 'mdi-dots-horizontal-circle' : 'mdi-dots-horizontal';
      },
      menuColor() {
        return 'var(--v-resBlue-darken1)';
      }
    },
    methods: {
      updateMenuState(isOpen) {
        this.menuOpen = isOpen;
      },
      performAction: function (action, params) {
        if (this.currentLoading) {
          this.$eventHub.$emit('showAlertNotification', `This page is currently busy, please wait and try again.`);
          return;
        }
        if (action.callback) {
          action.callback(action, params);
        }
        else {
          this.$emit('action-clicked', action, params);
        }
      },
      onRowSelectedChanged: function () {
        this.$emit('rowSelectedChanged')
        if (this.params.data.selectionChangedCallback) {
          this.params.data.selectionChangedCallback(this.params.data.isSelected);
        }
      },
      getParameterizedResult: function (attr, params) {
        if (!attr) {
          return '';
        }
        if (typeof attr == "function") {
          return attr(params.data);
        }
        return attr;
      }
    }
  }
</script>

<style scoped lang="scss">
  .res-action-group-header {
    background-color: white;
    height: 120px !important;
    border-left: 1px solid var(--v-resGrey-lighten3) !important;
    margin-left: -1px !important;
    max-width: unset;
    min-width: var(--min-width-stretch);
  }
  .res-action-group-header > span {
    line-height: 40px;
  }
  .right-top-bordered {
    border-top: 2px solid var(--v-resGrey-lighten3) !important;
    border-right: 4px solid var(--v-resGrey-lighten3) !important;
    margin-top: -4px;
  }
  .left-top-bordered {
    border-top: 2px solid var(--v-resGrey-lighten3) !important;
    border-left: 2px solid var(--v-resGrey-lighten3) !important
  }
  .group-label {
    font-family: Roboto, sans-serif;
    font-size: 12px !important;
    font-weight: 700;
    letter-spacing: 0.1px;
  }
  .action-controls {
    height: 100%;
    float: right;
    padding: 7px 6px 6px 6px;
  }
  .quick-icon {
    color: var(--v-resBlue-darken1);
  }
  .flagged {
    color: var(--v-resRed-darken1) !important;
  }
  .ellipses-control {
    height: 20px;
    width: 20px;
  }
  .ellipses-control-option-list {
    border-radius: 6px;
    border: 1px solid var(--v-resBlue-darken1);
  }
  .ellipses-control-option {
    font-size: 13px;
  }
  .locked {
      color: var(--v-resRed-darken2);
  }
  .unlocked {
    color: var(--v-resGrey-darken2);
  }
</style>
